import { Col, Container, Row } from "reactstrap";
import LeftSidebar from "../Common/LeftSidebar";
import RightSidebarCards from "../Common/RightSidebarCards";
import { Breadcrumbs } from "../../../../AbstractElements";
import { JobList, JobSearch } from "../../../../Constants/Constants";

const ListViewContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={JobList} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <Col xl="9" className="xl-60 box-col-12">
            <RightSidebarCards startLimit={0} endLimit={8} />
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default ListViewContainer;
